import { BadgeDollarSignIcon } from "lucide-react"
import { buttonVariants } from "@/components/ui/button"
import { config } from "@/config"
import { cn } from "@/utils/cn"

export function AffiliateProgramBanner() {
  return (
    <a
      href={config.links.affonso}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={cn(
        buttonVariants({ variant: "ghost" }),
        "mx-auto w-fit border border-dashed text-muted-foreground",
      )}
    >
      <BadgeDollarSignIcon />
      Get 20% recurring commission in our affiliate program
    </a>
  )
}
